<template>
  <div class="container">
    <pi-cell-row name="个人头像" :rightIcon="false">
      <img
        class="my-detail-image"
        :src="userInfo.headImgUrl | getFilePath"
        alt=""
      />
    </pi-cell-row>
    <pi-cell-row name="手机号码" :rightIcon="false">
      {{ userInfo.phoneNo }}
    </pi-cell-row>
    <pi-cell-row name="用户名" :rightIcon="false">
      {{ userInfo.userName }}
    </pi-cell-row>
    <pi-cell-row name="性别" :rightIcon="false">
      {{ userInfo.sex == 2 ? "女" : "男" }}
    </pi-cell-row>
  </div>
</template>

<script>
import cellRow from "@/components/pi-cell-row/pi-cell-row.vue";
import { getUserBaseInfo } from "../../common/api";

export default {
  components: {
    [cellRow.name]: cellRow,
  },
  data() {
    return {
      userInfo: {},
    };
  },
  mounted() {
    this.getUserBaseInfo();
  },

  methods: {
    async getUserBaseInfo() {
      let ret = await getUserBaseInfo({});
      if (ret.data) {
        let data = ret.data[0] || {};
        this.userInfo = data;
      }
    },
  },
};
</script>

<style scoped lang="less">
.my-detail-image {
  width: 0.88rem;
  height: 0.88rem;
  border: 0.03rem solid rgba(143, 142, 255, 0.38);
  border-radius: 50%;
  vertical-align: top;
}
</style>

